<template>
  <div class="edit-purchase-container">
    <ds-page-header :title="$t('editPurchaseApply.page.title')" :subtitle="$t('editPurchaseApply.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('editPurchaseApply.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="editApplyPurchaseSummit">
          {{ $t('editPurchaseApply.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('editPurchaseApply.title') }}</span>
      </div>
      <el-form label-width="120px">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('editPurchaseApply.contactPerson')">
              <el-input v-model="editPurchaseApplyInfo.endUserName"
                :placeholder="$t('editPurchaseApply.contactPersonPlaceholder')" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('editPurchaseApply.contactPhone')">
              <el-input v-model="editPurchaseApplyInfo.endUserTel"
                :placeholder="$t('editPurchaseApply.contactPhonePlaceholder')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('editPurchaseApply.applyDescription')">
              <el-input type="textarea" v-model="editPurchaseApplyInfo.description"
                :placeholder="$t('editPurchaseApply.applyDescriptionPlaceholder')" :rows="2" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('editPurchaseApply.purchaseItems') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openSelectResourceStoreDialog">
            {{ $t('editPurchaseApply.select') }}
          </el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="editPurchaseApplyInfo.resourceStores" border
        :empty-description="$t('editPurchaseApply.page.empty')">
        <el-table-column prop="type" :label="$t('editPurchaseApply.itemType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('editPurchaseApply.itemName')" align="center" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.resName }}({{ scope.row.resCode }})
          </template>
        </el-table-column>
        <el-table-column prop="spec" :label="$t('editPurchaseApply.itemSpec')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.rssName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('editPurchaseApply.price')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-select v-model="scope.row.timesId" @change="changeTimesId($event, scope.$index)" style="width: 100%">
              <el-option :value="''" :label="$t('editPurchaseApply.selectPrice')" />
              <el-option v-for="time in scope.row.times" :key="time.timesId" :value="time.timesId"
                :label="String(time.price)" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="stock" :label="$t('editPurchaseApply.itemStock')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ getTimesStock(scope.row) }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" :label="$t('editPurchaseApply.applyQuantity')" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity"
              :placeholder="$t('editPurchaseApply.applyQuantityPlaceholder')" :min="1" controls-position="right"
              style="width: 120px" />
            {{ scope.row.unitCodeName }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('editPurchaseApply.remark')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" :placeholder="$t('editPurchaseApply.remarkPlaceholder')" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('editPurchaseApply.operation')" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeSelectResourceStoreItem(scope.row.resId)">
              {{ $t('editPurchaseApply.remove') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <choose-resource-store2 ref="chooseResourceStoreDialog" @setSelectResourceStores="handleSelectResourceStores" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listPurchaseApplys, updatePurchaseApply } from '@/api/resource/editPurchaseApplyApi'
import ChooseResourceStore2 from '@/components/resource/chooseResourceStore2'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'EditPurchaseApplyList',
  components: { ChooseResourceStore2, DsPageHeader, DsToolbar, DsDataTable },
  data() {
    return {
      editPurchaseApplyInfo: {
        applyOrderId: '',
        resourceStores: [],
        description: '',
        endUserName: '',
        endUserTel: '',
        resOrderType: '10000',
        communityId: getCommunityId()
      }
    }
  },
  created() {
    this.editPurchaseApplyInfo.applyOrderId = this.$route.query.applyOrderId
    this.editPurchaseApplyInfo.resOrderType = this.$route.query.resOrderType || '10000'
    this.listPurchaseApply()
  },
  methods: {
    async listPurchaseApply() {
      try {
        const params = {
          page: 1,
          row: 1,
          applyOrderId: this.editPurchaseApplyInfo.applyOrderId,
          resOrderType: this.editPurchaseApplyInfo.resOrderType
        }
        const { data } = await listPurchaseApplys(params)
        if (data && data.length > 0) {
          const purchaseApply = data[0]
          Object.assign(this.editPurchaseApplyInfo, purchaseApply)
          this.editPurchaseApplyInfo.resourceStores = purchaseApply.purchaseApplyDetailVo || []
        }
      } catch (error) {
        console.error('获取采购申请详情失败:', error)
      }
    },
    openSelectResourceStoreDialog() {
      this.$refs.chooseResourceStoreDialog.open({
        shId: this.editPurchaseApplyInfo.shId
      })
    },
    handleSelectResourceStores(resourceStores) {
      const oldList = this.editPurchaseApplyInfo.resourceStores
      const newItems = resourceStores.filter(newItem => {
        return !oldList.some(oldItem => oldItem.resId === newItem.resId && (!newItem.times || newItem.times.length < 2))
      })
      this.editPurchaseApplyInfo.resourceStores = [...newItems, ...oldList]
    },
    async editApplyPurchaseSummit() {
      if (!this.editPurchaseApplyInfo.resourceStores || this.editPurchaseApplyInfo.resourceStores.length === 0) {
        this.$message.warning(this.$t('editPurchaseApply.noItemsSelected'))
        return
      }
      try {
        await updatePurchaseApply(this.editPurchaseApplyInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        console.error('提交采购申请失败:', error)
        this.$message.error(error.message || this.$t('editPurchaseApply.updateFailed'))
      }
    },
    removeSelectResourceStoreItem(resId) {
      this.editPurchaseApplyInfo.resourceStores = this.editPurchaseApplyInfo.resourceStores.filter(
        item => item.resId !== resId
      )
    },
    changeTimesId(timesId, index) {
      const times = this.editPurchaseApplyInfo.resourceStores[index].times
      const selectedTime = times.find(time => time.timesId === timesId)
      if (selectedTime) {
        this.editPurchaseApplyInfo.resourceStores[index].selectedStock = selectedTime.stock
      }
    },
    getTimesStock(resourceStore) {
      if (!resourceStore.timesId) return '-'
      if (!resourceStore.times) return 0
      const selectedTime = resourceStore.times.find(time => time.timesId === resourceStore.timesId)
      return selectedTime ? selectedTime.stock : 0
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-purchase-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
</style>
